

















import Password from '../components/Password.vue';
import ErrorGroup from '../components/ErrorGroup.vue';
import Heading from '../components/Heading.vue';
import {Action, State} from 'vuex-class';
import {Component, Vue, Watch} from 'vue-property-decorator';
import PasswordStrengthIndicator from '../components/PasswordStrengthIndicator.vue';
import {passwordStrengthCopy, validatePassword} from '@/helpers/validate-password';

@Component({
  components: {
    Password,
    ErrorGroup,
    Heading,
    PasswordStrengthIndicator,
  },
})
export default class ResetPassword extends Vue {
  @State('email') public email?: string;
  passwordStrengthCopy = passwordStrengthCopy;
  protected password: string = '';
  protected isValidPassword: boolean = false;
  protected isPrestinePassword: boolean = true;
  @Action('resetPassword') protected resetPasswordAction: any;

  protected handleSubmit() {
    this.resetPasswordAction({
      id: this.$route.query.Id as string,
      code: this.$route.query.code as string,
      password: this.password,
    });
  }

  @Watch('password')
  private onModelChanged(value: string, oldValue: string) {
    this.isValidPassword = validatePassword(value);
    this.isPrestinePassword = false;
  }
}
